import React from "react";
import AttendanceRulePreview from "../attendancePolicyPlanner/components/AttendanceRulePreview";
import { attendancePlannerDependencyMap } from "../attendancePolicyPlanner/policyDependencyConfig";

const NaturalPolicyPreview = ({ dependencyKey, record, allData, onClose }) => {
  const dependency = attendancePlannerDependencyMap[dependencyKey];

  return (
    <AttendanceRulePreview
      open={ true }
      preview={ {
        type: "rule",
        dependency,
        record,
        relatedData: allData,
      } }
      onClose={ onClose }
    />
  );
};

export default NaturalPolicyPreview;
